import api from '@/api/fetchClient'
export default {
    fetchParties() {
        return api.get('party/get', { authorized: true })
      }
}
